// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountSavePrescriberDefaultResponse {
    static getAttributeTypeMap() {
        return AccountSavePrescriberDefaultResponse.attributeTypeMap;
    }
}
AccountSavePrescriberDefaultResponse.discriminator = undefined;
AccountSavePrescriberDefaultResponse.additionalProperties = false;
AccountSavePrescriberDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "number"
    },
];
//# sourceMappingURL=accountSavePrescriberDefaultResponse.js.map